import React, { JSXElementConstructor, ReactElement } from "react";
import { SearchInput, SearchInputSmall } from "../components";
import { SearchApi } from "../interfaces";

export class SearchApiImpl implements SearchApi {
    getSearchComponent(showOnSmallScreen?: boolean): ReactElement<any, string | JSXElementConstructor<any>> {
        if (showOnSmallScreen) return <SearchInputSmall />
        return <SearchInput />
    }
}